/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dull_Round_Gorilla_ProsperInputs */

const fr_dull_round_gorilla_prosper = /** @type {(inputs: Dull_Round_Gorilla_ProsperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les 5 dernières demandes de contact`)
};

/**

* @param {Dull_Round_Gorilla_ProsperInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dull_round_gorilla_prosper = /** @type {((inputs?: Dull_Round_Gorilla_ProsperInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dull_Round_Gorilla_ProsperInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dull_round_gorilla_prosper(inputs)
});